import { render, staticRenderFns } from "./AdminMatchesTable.vue?vue&type=template&id=22854b46&scoped=true"
import script from "./AdminMatchesTable.vue?vue&type=script&lang=js"
export * from "./AdminMatchesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22854b46",
  null
  
)

export default component.exports